const pt = {
  // ── Navigation ─────────────────────────────
  nav: {
    dashboard: 'Painel',
    workOrders: 'Ordens',
    customers: 'Clientes',
    calendar: 'Calendario',
    invoices: 'Faturas',
    estimates: 'Orcamentos',
    inventory: 'Inventario',
    team: 'Equipe',
    reports: 'Relatorios',
    settings: 'Configuracoes',
    myWork: 'Meu trabalho',
    contracts: 'Contratos',
    tracking: 'Rastreamento',
    csat: 'CSAT',
    leaderboard: 'Ranking',
    bookings: 'Reservas',
    dispatch: 'Despacho',
    more: 'Mais',
  },

  // ── Common actions ─────────────────────────
  common: {
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    create: 'Criar',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    back: 'Voltar',
    close: 'Fechar',
    confirm: 'Confirmar',
    loading: 'Carregando...',
    saving: 'Salvando...',
    noResults: 'Sem resultados',
    required: 'Obrigatorio',
    optional: 'Opcional',
    all: 'Todos',
    active: 'Ativo',
    inactive: 'Inativo',
    yes: 'Sim',
    no: 'Nao',
    or: 'ou',
    of: 'de',
    showing: 'Mostrando',
    rows: 'linhas',
    page: 'Pagina',
    previous: 'Anterior',
    next: 'Proximo',
  },

  // ── Page titles ────────────────────────────
  pages: {
    dashboard: {
      title: 'Painel de controle',
      subtitle: 'Resumo da sua empresa',
    },
    workOrders: {
      title: 'Ordens de servico',
      subtitle: 'Gerencie as ordens de servico',
      new: 'Nova ordem',
      detail: 'Detalhe da ordem',
    },
    customers: {
      title: 'Clientes',
      subtitle: 'Gerencie seus clientes',
      new: 'Novo cliente',
      detail: 'Detalhe do cliente',
    },
    calendar: {
      title: 'Calendario',
      subtitle: 'Vista de planejamento',
    },
    invoices: {
      title: 'Faturas',
      subtitle: 'Faturamento e cobracas',
      new: 'Nova fatura',
    },
    estimates: {
      title: 'Orcamentos',
      subtitle: 'Gerencie seus orcamentos',
      new: 'Novo orcamento',
    },
    inventory: {
      title: 'Inventario',
      subtitle: 'Controle de materiais e estoque',
    },
    team: {
      title: 'Equipe',
      subtitle: 'Gerencie sua equipe de trabalho',
      invite: 'Convidar membro',
    },
    reports: {
      title: 'Relatorios',
      subtitle: 'Metricas e analises',
    },
    settings: {
      title: 'Configuracoes',
      subtitle: 'Configure sua conta e organizacao',
    },
  },

  // ── Auth ────────────────────────────────────
  auth: {
    login: 'Entrar',
    register: 'Criar conta',
    logout: 'Sair',
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar senha',
    forgotPassword: 'Esqueceu sua senha?',
    resetPassword: 'Redefinir senha',
    sendResetLink: 'Enviar link',
    newPassword: 'Nova senha',
    name: 'Nome',
    companyName: 'Nome da empresa',
    loginTitle: 'Bem-vindo de volta',
    loginSubtitle: 'Entre na sua conta WorSaaS',
    registerTitle: 'Crie sua conta',
    registerSubtitle: 'Comece a gerenciar sua empresa',
    forgotTitle: 'Recuperar senha',
    forgotSubtitle: 'Enviaremos um link para redefinir sua senha',
    resetTitle: 'Nova senha',
    resetSubtitle: 'Digite sua nova senha',
    continueWithGoogle: 'Continuar com Google',
    noAccount: 'Nao tem uma conta?',
    hasAccount: 'Ja tem uma conta?',
    passwordMinLength: 'Minimo 8 caracteres',
    invalidCredentials: 'Email ou senha incorretos',
    emailSent: 'Email enviado. Verifique sua caixa de entrada.',
    passwordChanged: 'Senha atualizada com sucesso',
  },

  // ── Work Orders ────────────────────────────
  workOrder: {
    status: {
      pending: 'Pendente',
      scheduled: 'Agendada',
      in_progress: 'Em andamento',
      completed: 'Concluida',
      cancelled: 'Cancelada',
      on_hold: 'Em espera',
    },
    priority: {
      low: 'Baixa',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente',
    },
    fields: {
      title: 'Titulo',
      description: 'Descricao',
      customer: 'Cliente',
      assignedTo: 'Atribuido a',
      service: 'Servico',
      scheduledDate: 'Data agendada',
      scheduledTime: 'Hora',
      priority: 'Prioridade',
      status: 'Status',
      address: 'Endereco',
      notes: 'Notas internas',
    },
  },

  // ── Invoices ───────────────────────────────
  invoice: {
    status: {
      draft: 'Rascunho',
      sent: 'Enviada',
      paid: 'Paga',
      overdue: 'Vencida',
      cancelled: 'Cancelada',
    },
    fields: {
      number: 'Numero',
      customer: 'Cliente',
      issueDate: 'Data de emissao',
      dueDate: 'Data de vencimento',
      subtotal: 'Subtotal',
      tax: 'Imposto',
      total: 'Total',
    },
  },

  // ── Settings tabs ──────────────────────────
  settings: {
    tabs: {
      general: 'Geral',
      services: 'Servicos',
      checklists: 'Checklists',
      notifications: 'Notificacoes',
      automations: 'Automatizacoes',
      customFields: 'Campos',
      integrations: 'Integracoes',
      billing: 'Faturamento',
    },
    language: {
      title: 'Idioma',
      subtitle: 'Selecione o idioma da interface',
    },
  },

  // ── Toasts / feedback ─────────────────────
  toast: {
    saved: 'Salvo com sucesso',
    deleted: 'Excluido com sucesso',
    created: 'Criado com sucesso',
    updated: 'Atualizado com sucesso',
    error: 'Ocorreu um erro',
    errorSaving: 'Erro ao salvar',
    errorDeleting: 'Erro ao excluir',
    errorLoading: 'Erro ao carregar os dados',
    copied: 'Copiado para a area de transferencia',
  },

  // ── Empty states ──────────────────────────
  empty: {
    workOrders: 'Nenhuma ordem de servico',
    customers: 'Nenhum cliente',
    invoices: 'Nenhuma fatura',
    estimates: 'Nenhum orcamento',
    inventory: 'Nenhum item no inventario',
    team: 'Nenhum membro na equipe',
  },
} as const;

export default pt;
